const countyConfigAlertSettingsReducer = (state = [], action) => {
  switch (action.type) {
    case 'LANDNOTIFICATION_COUNTY_CONFIG_ALERT_SETTINGS':
      return action.results;
    default:
      break;
  }
  return state;
}

export default countyConfigAlertSettingsReducer;